import styled from '@emotion/styled';

const Shin:React.FC<any> = () => {
  // const handleFirstBlog = () => {
  //   window.open("https://blog.naver.com/Sinhana5819/223463317908", "_blank")
  // };
  return (
    <Container>
      <ImgContainer>
        <Img src="/images/klikkie/main/review/review2.png"/>
      </ImgContainer>
      {/* <CardContainer>
        <Card>
        <BlurContainer/>
        <BlurContainer className="Bottom"
        >
          <TextContainer>
            <MainText>
              "엄마가 앞으로는 매달 잊지않고 한달에<br/> 
              6장씩 인화해서 꽂아둘께🤍"
            </MainText>
          <br/>★★★★★
          <br/>신*인님
          <BottomTextContainer>
            <TextBlock>5개월 구독중</TextBlock>
          </BottomTextContainer>
          </TextContainer>
        </BlurContainer>
        </Card>
      </CardContainer> */}
    </Container>
  )
};

export default Shin;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  /* background-color: yellow; */
`;
const ImgContainer = styled.div`
  width: 100%;
  margin-bottom: 20px;
`

const Img = styled.img`
  width: 100%;
`

const Card = styled.div`
  width: 100%;
  height: 519px;
  background-image: url("/images/millie/shinCard.png");
  background-size: cover;
  display: flex;
  flex-direction: column;
`;

const BlurContainer = styled.div`
  width: 100%;
  height: 50%;
  
  display: flex;

  &.Bottom {
    background-color: rgba(188, 186, 176, 0.7);
    backdrop-filter: blur(5px); /* 오버레이 배경을 흐리게 만듦 */
  }
`;

const TextContainer = styled.div`
  width: 80%;
  margin: 20px auto;
  /* background-color: aquamarine; */
  color: white;
  font-size: 16px;
  line-height: 1.5;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const MainText = styled.span`
  font-size: 20px;
`

const BottomTextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`;
const TextBlock = styled.div`
  width: 50%;
  /* display: flex;
  flex-direction: ; */

  span {
    font-size: 15px;
  }
`

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 60px;
  /* height: 80%; */
  justify-content: space-between;
`